import RelatorioIndex from '../relatorio/pages/RelatorioIndex.vue';
import { laisPath } from '../laisRouteHelpers';

export default {
  path: laisPath('minha-atividade'),
  component: RelatorioIndex,
};
